// Tailwind removed -> custom CSS
// AOS initialized centrally in LandingPage

const WCU = () => {
  return (
    <div className="section-spacing lp-container">
      <div className="section-header-end">
        <hr
          data-aos="fade-right"
          className="section-line"
          style={{ marginRight: "1rem" }}
        />
        <h2 data-aos="fade-left" className="section-title">
          KEY FEATURES
        </h2>
      </div>
      <div className="card-grid wcu" style={{ gap: "1.5rem" }}>
        <div
          data-aos="flip-left"
          className="wcu-card bg-gray"
          style={{ position: "relative", padding: "1.5rem" }}
        >
          <img src="/check1.png" alt="Check" className="wcu-check-icon" />
          <h3 className="wcu-card-title">OSINT Collection</h3>
          <p className="wcu-card-text">
            Structured collection of open-source intelligence to assess how the
            organization is visible across public data, services and digital
            ecosystems.
          </p>
        </div>
        <div
          data-aos="fade-up"
          className="wcu-card bg-teal"
          style={{ position: "relative", padding: "1.5rem" }}
        >
          <img src="/check1.png" alt="Check" className="wcu-check-icon" />
          <h3 className="wcu-card-title">External Scans</h3>
          <p className="wcu-card-text">
            Focused analysis of internet-facing assets to identify exposed
            services, misconfigurations and exploitable vulnerabilities.
          </p>
        </div>
        <div
          data-aos="flip-right"
          className="wcu-card bg-gray"
          style={{ position: "relative", padding: "1.5rem" }}
        >
          <img src="/check1.png" alt="Check" className="wcu-check-icon" />
          <h3 className="wcu-card-title">Dark Web Monitoring</h3>
          <p className="wcu-card-text">
            Targeted research of underground sources to detect leaked
            credentials, brand mentions and indicators linked to your domains.
          </p>
        </div>
        <div
          data-aos="fade-up"
          className="wcu-card bg-teal"
          style={{ position: "relative", padding: "1.5rem" }}
        >
          <img src="/check1.png" alt="Check" className="wcu-check-icon" />
          <h3 className="wcu-card-title">Threat Modeling & Knowledge Graph</h3>
          <p className="wcu-card-text">
            A security knowledge graph correlates assets, vulnerabilities and
            attacker techniques to construct realistic, context-specific attack
            paths.
          </p>
        </div>
        <div
          data-aos="zoom-in"
          className="wcu-card bg-gray"
          style={{ position: "relative", padding: "1.5rem" }}
        >
          <img src="/check1.png" alt="Check" className="wcu-check-icon" />
          <h3 className="wcu-card-title">FAIR-Based Quantification</h3>
          <p className="wcu-card-text">
            Each scenario is evaluated using FAIR to translate likelihood and
            impact into financial loss ranges and Annual Loss Expectancy.
          </p>
        </div>
        <div
          data-aos="fade-down"
          className="wcu-card bg-teal"
          style={{ position: "relative", padding: "1.5rem" }}
        >
          <img src="/check1.png" alt="Check" className="wcu-check-icon" />
          <h3 className="wcu-card-title">AI & LLM-Driven Analysis</h3>
          <p className="wcu-card-text">
            Specialized AI agents and LLMs operate on a structured knowledge
            base to contextualize findings, validate assumptions and generate
            consistent risk assessments at scale.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WCU;
